import React from 'react';
import { Controller } from 'react-hook-form';
import {
    Title, Paragraph, Checkbox, Icon, Button,
    Loader,
} from 'ui-library';

import { ICON_EDIT_RECT } from 'ui-library/components/Icon';
import { BUTTON_TYPE_LINK } from 'ui-library/components/Button/constants';
import './Summary.css';

const Summary = ({ datasource }) => {
    const {
        control,
        errors,
        data,
        t,
        handleEditCase,
        isPaymentOrderPrivateAccount,
        isActive3bPortfoliosLoading,
    } = datasource();

    const {
        isPartialSale,
        orderType,
        productName,
        currentInvestmentAmount,
        withdrawalAmount,
        remainingInvestmentAmount,
        reasonForSale,
        reasonForSaleText,
        beneficiaryFullName,
        beneficiaryAddress,
        beneficiaryZipAndCity,
        depotTitle,
        iban,
        esr,
        bankName,
        message1,
        message2,
        subscriptionFeeConsideration,
        subscriptionFeeConsiderationText,
    } = data || {};

    return (
        <form>
            <Title type="3">
                {orderType}
                <Button
                    type={BUTTON_TYPE_LINK}
                    className="create-new-case-summary--edit"
                    onClick={handleEditCase}
                    aria-label={t('CreateNewCase.Summary.Edit')}
                >
                    <Icon type={ICON_EDIT_RECT} size={20} />
                </Button>
            </Title>

            <div className="text-group">
                <Paragraph className="para-secondary">{productName}</Paragraph>
            </div>

            <div className="text-group">
                <Title type="4">{t('CreateNewCase.Summary.Title.CurrentInvestmentAmount')}</Title>
                <Paragraph>{currentInvestmentAmount}</Paragraph>
            </div>

            <div className="text-group">
                <Title type="4">{t('CreateNewCase.Summary.Title.WithdrawalAmount')}</Title>
                <Paragraph>{withdrawalAmount}</Paragraph>
            </div>

            {isPartialSale && (
                <div className="text-group">
                    <Title type="4">{t('CreateNewCase.Summary.Title.RemainingInvestmentAmount')}</Title>
                    <Paragraph>{remainingInvestmentAmount}</Paragraph>
                </div>
            )}

            {!isPaymentOrderPrivateAccount && (
                <>
                    <Title type="3" style={{ marginTop: 48 }}>{t('CreateNewCase.Summary.Title.ReasonForSale')}</Title>

                    <div className="text-group">
                        <Title type="4">{t('CreateNewCase.Summary.Title.ReasonForSale')}</Title>
                        <Paragraph>{reasonForSale}</Paragraph>
                        <Paragraph>{reasonForSaleText}</Paragraph>
                    </div>
                </>
            )}

            <Title type="3" style={{ marginTop: 48 }}>{t('CNC.BankInfo.beneficiaryInfo.title')}</Title>

            <div className="text-group">
                <Paragraph>{beneficiaryFullName}</Paragraph>
                <Paragraph>
                    {beneficiaryAddress ? `${beneficiaryAddress}, ` : ' '}
                    {beneficiaryZipAndCity}
                </Paragraph>
            </div>

            <Title type="3" style={{ marginTop: 48 }}>{t('CNC.BankInfo.beneficiaryInfo.AccountDetails.title')}</Title>
            <div>
                {isActive3bPortfoliosLoading ? <Loader /> : depotTitle && (
                    <div className="text-group">
                        <Paragraph>{depotTitle}</Paragraph>
                    </div>
                )}
            </div>

            <div className="text-group">
                <Title type="4">{t('3b.withdrawalPlan.bankIban')}</Title>
                <Paragraph>{iban}</Paragraph>
            </div>

            {esr && (
                <div className="text-group">
                    <Title type="4">{t('3b.withdrawalPlan.esr')}</Title>
                    <Paragraph>{esr}</Paragraph>
                </div>
            )}

            <div className="text-group">
                <Title type="4">{t('CreateNewCase.Summary.Title.BANK')}</Title>
                <Paragraph>{bankName}</Paragraph>
            </div>

            {message1 && (
                <div className="text-group">
                    <Title type="4">{isPaymentOrderPrivateAccount ? t('CNC.BankInfo.messageText1') : t('CNC.BankInfo.messageText1')?.slice(0, -1)}</Title>
                    <Paragraph>{message1}</Paragraph>
                </div>
            )}

            {message2 && isPaymentOrderPrivateAccount && (
                <div className="text-group">
                    <Title type="4">{t('CNC.BankInfo.messageText2')}</Title>
                    <Paragraph>{message2}</Paragraph>
                </div>
            )}

            {subscriptionFeeConsideration && (
                <div className="text-group">
                    <Title type="4">{t('CreateNewCase.Summary.Title.SubscriptionFeeConsiderationText')}</Title>
                    <Paragraph>{subscriptionFeeConsiderationText}</Paragraph>
                </div>
            )}

            <div className="text-group" style={{ marginTop: 48 }}>
                <div>
                    <Controller
                        name="isEmailRetention"
                        control={control}
                        render={({ field: { value, ...field } }) => (
                            <Checkbox
                                {...field}
                                checked={value}
                                label={t('CreateNewCase.Summary.Checkbox.Label.TriggerRetentionMail')}
                                error={t(errors?.isEmailRetention?.message)}
                            />
                        )}
                    />
                </div>
            </div>
        </form>
    );
};

export default Summary;
